import { put, call, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import EventFactory from "../../Entity/Factories/EventFactory";
import { EventInterface } from "../../Entity/Entities/Event/EventInterface";
import Translator from "../../Translation/Translator";

export default function* eventUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_EVENT_UPDATE_CLEAR
    });

    const res = yield call(Http.put, `events/${action.payload?.id}`, action.payload);

    const event: EventInterface = EventFactory.create(res.data);

    yield put({
      type: Constants.GLOBAL_EVENT_UPDATE_SUCCESS,
      payload: {
        event: event
      }
    });

    if(!action.payload?.clickSendEmail) {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-event-updated-successfully", {eventname: Translator.trans(event?.entityTransKey)}),
          type: "success"
        }
      });
    }

    yield put({
      type: Constants.GLOBAL_EVENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, event);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_EVENT_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchEventUpdate() {
  yield takeEvery(Constants.GLOBAL_EVENT_UPDATE_START, eventUpdate);
}
